import request from "@/utils/request";

// 获取考试列表
export function getExamList(data) {
  return request({
    url: "local_exam_search_exam",
    method: "GET",
    params: data,
  });
}
// 添加考试
export function getAddExamList(data) {
  return request({
    url: "local_exam_create_exam",
    method: "GET",
    params: data,
  });
}
// 编辑考试
export function getEditExam(data) {
  return request({
    url: "local_exam_edit_exam",
    method: "GET",
    params: data,
  });
}
// 删除考试
export function getDelExam(data) {
  return request({
    url: "local_exam_delete_exam",
    method: "GET",
    params: data,
  });
}
// 获取课程
export function getCourses(data) {
  return request({
    url: "core_course_get_courses_by_field",
    method: "POST",
    data,
  });
}
